import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { addCampaignGalleryImage } from 'services/api/campaign';
import { RootState } from 'store';
import { CampaignFile } from 'types/campaign/collaborations'

const LinkIGMediaAsSamplePost: React.FC<{ isOpen: boolean, onClose: () => void, onSuccess: (campaignFile: CampaignFile) => void, milestoneId: number }> = ({ milestoneId, isOpen, onClose, onSuccess }) => {

    const [igURL, setIGURL] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const { campaignId } = useParams();
    const selectedAgencyId = useSelector((state: RootState) => state.auth.selectedAgencyId);

    useEffect(() => {
        if (isOpen) setIGURL('');
    }, [isOpen, milestoneId])

    const linkMedia = async () => {
        if (!igURL || !campaignId || !selectedAgencyId) return;
        setSubmitting(true);
        try {
            const formData = new FormData();
            formData.append('url', igURL);
            formData.append('type', 'sample_post');
            formData.append("milestone_id", String(milestoneId));
            const uploadedFile = await addCampaignGalleryImage(selectedAgencyId, campaignId, formData);
            if (uploadedFile.success) {
                onSuccess({ filename: uploadedFile.name, uuid: uploadedFile.uuid, url: uploadedFile.url, type: 'sample_post' });
            }
        } catch (error: any) {
            console.log(error);
            toast.error(error?.response?.data?.message ?? 'Failed to upload file, please try again!')
        } finally {
            setSubmitting(false)
        }
    }


    return (
        <Modal isOpen={isOpen} toggle={() => onClose()} centered>
            <ModalHeader className='border-bottom p-3'>
                <span className="fw-bold">Link IG Media - Sample Post</span>
            </ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label>URL</Label>
                    <Input
                        type='url'
                        value={igURL}
                        onChange={(e) => setIGURL(e.target.value)}
                    />
                </FormGroup>
            </ModalBody>
            <ModalFooter className='border-top py-2'>
                <div className="d-flex justify-content-end gap-2 align-items-center">
                    <button className="theme-btn btn-gradient" onClick={linkMedia} disabled={!igURL || submitting}>{submitting ? 'Linking...' : 'Link'}</button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default LinkIGMediaAsSamplePost